import { useState } from 'react';
import { components } from 'react-select';
import { Button, Modal } from 'react-bootstrap';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useDisclosure from 'shared/hooks/misc/useDisclosure';
import CommonButton from 'shared/components/common/Button';
import { toTitleCase } from 'shared/utils/string';

export function useAsyncSelectCreatable({
  formId = '',
  modalSize = 'lg',
  modalTitle = 'Create New',
  buttonLabel = 'Add New',
} = {}) {
  if (!formId)
    throw new Error('useAsyncSelectCreatable must be used with a form ID');

  const [canSubmit, setCanSubmit] = useState(false);
  const [isModalOpen, { onToggle }] = useDisclosure();
  const menuProps = { buttonLabel, onToggle };
  const modalProps = {
    formId,
    canSubmit,
    modalSize,
    modalTitle,
    visible: isModalOpen,
    onDismiss: onToggle,
  };
  return { menuProps, modalProps, setCanSubmit, setSubmitted: onToggle };
}

export function CreatableMenu({ buttonLabel, onToggle, ...props }) {
  return (
    <components.Menu {...props}>
      <Button
        size="sm"
        variant="light"
        onClick={onToggle}
        onTouchEnd={onToggle}
        className="m-2 mb-1 pe-3 d-flex align-items-center"
      >
        <FontAwesomeIcon icon={faPlus} color="#ececec" />
        <div className="ms-2 text-secondary">{toTitleCase(buttonLabel)}</div>
      </Button>
      {props.children}
    </components.Menu>
  );
}

export function CreatableModal({
  formId,
  children,
  canSubmit,
  modalSize,
  modalTitle,
  visible,
  onDismiss,
  ...props
}) {
  return (
    <Modal
      centered
      size={modalSize}
      show={visible}
      onHide={onDismiss}
      {...props}
    >
      <Modal.Header className="ps-4" closeButton>
        <Modal.Title as="h6">{toTitleCase(modalTitle)}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-5 py-4">{children}</Modal.Body>
      <Modal.Footer>
        <CommonButton type="text" onClick={onDismiss}>
          Cancel
        </CommonButton>
        <CommonButton type="submit" form={formId} disabled={!canSubmit}>
          Create
        </CommonButton>
      </Modal.Footer>
    </Modal>
  );
}
